import { useEffect, useRef } from 'react';
import { Animated } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useTheme } from '@/contexts/ThemeContext';
import DuelsScreen from '@/components/DuelsScreen';
import TutorialOverlay from '@/components/TutorialOverlay';

export default function DuelsTab() {
  const { theme } = useTheme();
  const fadeAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(fadeAnim, { toValue: 1, duration: 300, useNativeDriver: true }).start();
  }, []);

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: theme.colors.background }} edges={['top']}>
      <Animated.View style={{ flex: 1, opacity: fadeAnim }}>
        <DuelsScreen />
      </Animated.View>
      <TutorialOverlay screenKey="duels" />
    </SafeAreaView>
  );
}
